export default __webpack_public_path__ + "soren_kierkegaard.836a741.jpeg";